import { animate, state, style, transition, trigger } from '@angular/animations';
import { Location } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-right-side-popup',
  templateUrl: './right-side-popup.component.html',
  styleUrls: ['./right-side-popup.component.css'],
  animations: [
    trigger('moveContainer', [
      state('initial', style({ transform: 'translateX(100%)' })), // Initial position
      state('final', style({ transform: 'translateX(0%)' })), // Final position (adjust the value as needed)
      transition('initial => final', animate('300ms ease-in')), // Animation duration and easing
      transition('final => initial', animate('300ms ease-out')), // Animation duration and easing
    ]),
  ],
})
export class RightSidePopupComponent implements OnInit, AfterViewInit {

  @Input('title') title = '';
  @Input('origin') origin = '';
  @Input('navigationAllowed') navigationAllowed = true;

  @Output() onClose = new EventEmitter<boolean>();

  animationState: 'initial' | 'final' = 'initial';

  constructor(
    private cdr: ChangeDetectorRef,
    private router: Router,
    private actRoute: ActivatedRoute,
    private location: Location
  ) { }

  ngOnInit(): void {}

  ngAfterViewInit() {
    this.animationState = 'final';
    this.cdr.detectChanges();
  }

  back() {
    this.animationState = 'initial';
    this.onClose.emit(true)
    setTimeout(() => {
      if(!this.navigationAllowed) {
        return
      }
      if(this.origin) {
        this.actRoute.queryParams.subscribe(params => {
          const callbackurl = params['callbackurl'];
          if(!callbackurl) {
            this.location.back();
          } else if(callbackurl) {
            const decoded = decodeURIComponent(callbackurl)
            this.router.navigateByUrl(decoded);
          }
        })
        } else {
        this.router.navigate(['..'], {relativeTo: this.actRoute});
      }
    }, 300);
  }

}
